<mgl-map [style]="'mapbox://styles/robertstadnick/cllvd0l2p006f01r6dh4j8w0s'" [zoom]="[10]" [center]="mapCenter" (mapCreate)="setMap($any($event))">
  <!-- <mgl-marker *ngFor="let data of quote_data$ | async" [lngLat]="data.location">
        <div class="marker">
            <i class="bi bi-geo-fill fs-2x text-dark" ngbTooltip="$5000.00"></i>
        </div>
    </mgl-marker> -->
</mgl-map>
